import { http } from '../api/http';

export type AdminUserStatus = 'pending' | 'review' | 'missing_docs' | 'approved' | 'rejected';

export interface AdminUser {
  id: number;
  name: string;
  email: string;
  role: string;
  createdAt: string;
  status: AdminUserStatus;
}

export interface UserKycSummary {
  userId: number;
  kycStatus: 'not_started' | 'pending' | 'approved' | 'rejected';
  pldStatus: 'not_started' | 'pending' | 'approved' | 'rejected';
  lastUpdate?: string;
}

export interface RejectPayload {
  reason?: string;
}

export const UsersService = {
  getPending(query?: string) {
    const qs = query ? `?q=${encodeURIComponent(query)}` : '';
    return http<AdminUser[]>(`/admin/users/pending${qs}`);
  },

  approve(userId: number) {
    return http<{ ok: true }>(`/admin/users/${userId}/approve`, { method: 'POST' });
  },

  reject(userId: number, payload?: RejectPayload) {
    return http<{ ok: true }>(`/admin/users/${userId}/reject`, { method: 'POST', body: payload || {} });
  },

  getKycSummary(userId: number) {
    return http<UserKycSummary>(`/admin/users/${userId}/kyc-summary`);
  },

  markMissingDocs(userId: number, payload?: RejectPayload) {
    return http<{ ok: true }>(`/admin/users/${userId}/missing-docs`, { method: 'POST', body: payload || {} });
  }
};
